import { useParams } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { NavButton } from "./NavButton";

interface LessonNavigationProps {
  currentLessonIndex: number;
  goToLesson: (args: any) => void;
  isEditing?: boolean;
  orderedLessons: any[];
}

export const LessonNavigation = ({
  orderedLessons,
  currentLessonIndex,
  goToLesson,
  isEditing = false,
}: LessonNavigationProps) => {
  const params: {
    spaceSlug: string;
  } = useParams();

  const nextLesson = orderedLessons[currentLessonIndex + 1];
  const previousLesson = orderedLessons[currentLessonIndex - 1];
  const hasNext = nextLesson != null;
  const canAccessNextLesson =
    !nextLesson?.needs_to_complete_previous_lesson || isEditing;
  const hasPrevious = previousLesson != null;

  const handleLessonChange = ({ id, section_id }: any) => {
    goToLesson({
      lessonId: id,
      sectionId: section_id,
      spaceSlug: params.spaceSlug,
    });
  };

  return (
    <div className="mt-3 flex items-center space-x-3">
      <NavButton
        disabled={!hasPrevious}
        iconType="16-arrow-left"
        onClick={() => handleLessonChange(previousLesson)}
        aria-label={t("courses.go_to_previous_lesson")}
      />
      <NavButton
        disabled={!hasNext || !canAccessNextLesson}
        iconType="16-arrow-right"
        onClick={() => handleLessonChange(nextLesson)}
        aria-label={t("courses.go_to_next_lesson")}
      />
    </div>
  );
};
